import * as React from 'react';

const Upload = ({ width = 24, height = 24, fill, viewBox = '0 0 24 24', ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} fill='none' viewBox={viewBox} {...props}>
      <rect width={width} height={height} fill={fill} rx={16} />
      <path
        fill='#fff'
        d='M15.27 19.602v-7.787l-2.508 2.508-1.035-1.05L16 9l4.273 4.273-1.035 1.05-2.509-2.508v7.787h-1.458ZM10.459 23c-.393 0-.735-.145-1.024-.434-.29-.29-.434-.63-.434-1.024v-2.96h1.458v2.96h11.084v-2.96H23v2.96c0 .393-.145.735-.434 1.024-.29.29-.63.434-1.024.434H10.458Z'
      />
    </svg>
  );
};
export default Upload;
